// removed by extract-text-webpack-plugin
module.exports = {"HeaderBackground":"Contact__HeaderBackground__25HfA","Logo":"Contact__Logo__TjsRN","SectionTitle":"Contact__SectionTitle__szwap","FormFrame":"Contact__FormFrame__1r7QG","SubmitButton":"Contact__SubmitButton__qhA0d","ContactInfo":"Contact__ContactInfo__2I5FX","TelTitle":"Contact__TelTitle__1nNu2","TelContent":"Contact__TelContent__2z7Mk","Title":"Contact__Title__2sZpK","Content":"Contact__Content__2slks"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Contact/Contact.css
// module id = 218
// module chunks = 0